import { computed } from 'vue'
import { useStore } from 'vuex-composition-helpers'

export function useUserName() {
  const store = useStore()

  const currentUserContext = computed(() => store.getters['permissions/getContext'])
  const isGlobalAdmin = computed<boolean>(() => store.getters['permissions/isGlobalAdmin'])

  const name = computed<string>(() => {
    const n = currentUserContext.value.name
    if (n != null) return n
    if (isGlobalAdmin.value) {
      return 'Global Admin'
    }
    return ''
  })

  return {
    name,
    currentUserContext,
    isGlobalAdmin,
  }
}
